import React from "react";

const Content = ({ ...props }) => {
  return (
    <div className="nk-content p-0 ">
      <div className="container-fluid p-0 ">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            {!props.page ? props.children : null}
            {props.page === "component" ? (
              <div className="components-preview wide-lg mx-auto">{props.children}</div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Content;
